import { ReactNode, useEffect } from "react"
import { configure } from "pokal_api"
import expectJwt from "../storage/jwt"
import { useAppDispatch } from "../redux/store/hooks"
import { pokalApiConfigured } from "../redux/PokalApiToaster"

interface PokalApiConfigurationProviderProps {
    children: ReactNode
}

function PokalApiConfigurationProvider(
    props: PokalApiConfigurationProviderProps
) {
    const dispatch = useAppDispatch()

    useEffect(() => {
        const isProduction = process.env.REACT_APP_MODE === "production"

        if (!process.env.REACT_APP_MODE) console.log("NO MODE SET")
        else
            console.log(
                isProduction ? "PRODUCTION" : "DEVELOPMENT"
            )
            console.log(`Backend URL: ${window.location.origin}`)
            
        configure({
            backend: isProduction
                ? `${window.location.origin}/api`
                : "http://localhost:3002",
            tokenRetriever: expectJwt,
            toaster: (title: string, message: string) => {
                alert(`${title}: ${message}`)
            }
        })
        dispatch(pokalApiConfigured())
    }, [])

    return <>{props.children}</>
}

export default PokalApiConfigurationProvider
